@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <div
    uiinputcontent
    (click)="
      permDir.uipermission() === PERMISSIONS.VIEW || settings().disabled
        ? false
        : updateValue(!value())
    "
  >
    <!--#region Label Left -->

    @if (settings().labelPosition === 'left') {
      <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
    }
    <ng-content select="label[slot-left]"></ng-content>

    <!--#endregion Label Left -->
    <input
      #uiValueRef
      uivalue
      type="checkbox"
      [class]="inputCssClass()"
      [checked]="value()"
      [class.checked]="value()"
    />

    <icon
      uiinputicon
      [class.checked]="value()"
      [iconDefinition]="value() ? ICONS.CHECK : undefined"
    ></icon>

    <!--#region Label Right -->

    @if (settings().labelPosition === 'right') {
      <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
    }
    <ng-content select="label[slot-right]"></ng-content>

    <!--#endregion Label Right -->

    <!--#region Tools -->

    <div uitoolstrip>
      <ng-content #uiToolsMarkupRef select="[uitool]"></ng-content>
      <ng-template #uiToolsCodeRef></ng-template>
    </div>

    <!--#endregion Tools -->
  </div>

  <!--#region Templates -->

  <!-- Label Template -->
  <ng-template #uiLabelTemplateRef>
    @if (label()) {
      <label
        [class]="labelCssClass()"
        [class.checked]="value()"
        [label]="labelFormatted()"
        [labelTip]="labelTip()"
        [state]="state()"
      >
      </label>
    }
  </ng-template>

  <!--#endregion Templates-->
}
